var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.light)?_c('span',[_vm._v(_vm._s(_vm.currencyFormat(_vm.value)))]):_c('v-chip',{attrs:{"dark":"","color":_vm.color,"outlined":""}},[_vm._v(_vm._s(_vm.currencyFormat(_vm.value)))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }